export default __webpack_public_path__ + "static/shopback_1-1a9777905f8afd09f70707b93f95d208.jpg";